import { Component, OnInit } from '@angular/core';
import { AlertMessage } from 'src/app/template/models/alert-message.model';
import { Student } from '../../models/student.model';
import { StudentService } from '../../services/student.service';

@Component({
    selector: 'app-students-list',
    templateUrl: './students-list.component.html',
    styleUrls: ['./students-list.component.scss']
})
export class StudentsListComponent implements OnInit {

    public headerTitle     : string = 'Participantes';
    public headerButtonText: string = 'Nuevo participante';
    public headerButtonIcon: string = 'plus-square';
    public headerButtonUrl : string = '/participante/nuevo';

    public students: Student[];

    public isLoadingData : boolean = true;
    public loadingMessage: AlertMessage = new AlertMessage();
    public loadingErrorMessage: string  = 'Se ha producido un error al cargar la página.';
    public emptyMessage: string = 'No tiene ningún participante dado de alta.<br/>Pulse sobre el botón NUEVO para dar de alta un nuevo participante.';

    constructor(private studentService: StudentService) { }

    ngOnInit() {

        this.initData();

    }

    private initData() {

        this.studentService.get().subscribe({

            next: (data: Student[]) => {
                this.students = data;
            },

            error: (error: any) => {
                this.loadingMessage.showDangerAlert(this.loadingErrorMessage);
            }

        }).add(() => {
            this.isLoadingData = false;
        });

    }

    public updateStudentsList() {

        this.isLoadingData = true;
        this.initData();

    }

}
